export default __webpack_public_path__ + "static/media/small.b4906f87.jpg";